import styled from 'styled-components/native';

import Placeholder from '../../elements/Placeholder';
import { useTranslation } from '../../i18n';
import { makeDataByIdKey } from '../../redux/selectors/vendorDetailSelector';
import { useSelector } from '../../redux/utils';

export interface Props {
  id: string;
}

export default ({ id }: Props) => {
  const { t } = useTranslation();

  const productAmount = useSelector(makeDataByIdKey(id, 'product_amount'));

  if (typeof productAmount === 'undefined') {
    return (
      <S.Container>
        <Placeholder width={167} height={18} />
      </S.Container>
    );
  }

  return (
    <S.Container>
      <S.Text>{t('vendor-product-amount', { amount: productAmount })}</S.Text>
    </S.Container>
  );
};

const S = {
  Container: styled.View`
    padding: 15px 15px 5px 15px;
    background-color: ${({ theme }) => theme.palette.white};
  `,
  Text: styled.Text`
    color: ${({ theme }) => theme.palette.neutralDark};
    font-size: 15px;
    line-height: 21px;
  `,
};
